module.exports = __webpack_public_path__ + "static/media/products.0d796e22.jpg";